<template>
  <div>

    <section class="content">
      <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-cyan" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku ">
                    <div class="col-md-3 searching">
                        <span class="h_page">Verifikasi Instrumen Komite Sekolah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 20%">Nama Responden</th>
                            <th style="width: 20%">Jabatan</th>
                            <th style="width: 30%">Sekolah</th>
                            <th style="width: 10%">Status</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                            <td class="text-center" :style="cekStatus(data.status)">{{index+1}}.</td>
                            <td>{{data.profile_id.profile.nama}}</td>
                            <td>{{data.profile_id.profile.jabatan}}</td>
                            <td>{{data.sekolah.type}} {{data.sekolah.status}} {{data.sekolah.sekolah}}</td>
                            <td>{{data.status}}</td>
                            <td class="text-center" >
                              <button class="btn bg-light-blue btn-xs waves-effect" @click="viewData(data.data_id)" title="Lihat Data" data-toggle="modal" data-target="#m_lihat_data">
                                  <i class="material-icons" >search</i>
                              </button>
                              <button class="btn bg-light-green btn-xs waves-effect" @click="viewId(data.data_id)" title="Setujui Data" data-toggle="modal" data-target="#m_setujui_data">
                                  <i class="material-icons" >done</i>
                              </button>
                              <button class="btn bg-red btn-xs waves-effect" @click="viewId(data.data_id)" title="Kembalikan Data" data-toggle="modal" data-target="#m_kembalikan_data">
                                  <i class="material-icons" >clear</i>
                              </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>

                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_setujui_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan penilaian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>



                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="setujuiData" class="btn btn-success waves-effect">SETUJUI</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_kembalikan_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-deep-orange">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan pengembalian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="kembalikanData" class="btn bg-deep-orange waves-effect">KEMBALIKAN</button>
                                    <button type="button" class="btn bg-red waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                                </div>
                                <div class="modal-body">


                                  <div class="table-responsive">
                                    <table class="table table-bordered table-striped" style="width: 100%">
                                        <thead>
                                          <tr class="bg-info">
                                            <th style="width: 5%"></th>
                                            <th style="width: 95%"></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                              <td class="text-center">1.</td>
                                              <td>
                                                Apakah Saudara memiliki Juklak/Juknis dana BOS? <br> <br>
                                                <div class="demo-radio-button">
                                                  <input name="group1" type="radio" id="radio_1" class="with-gap" v-model="soal_1" value="ya" disabled><label for="radio_1">Ya</label>
                                                  <input name="group1" type="radio" id="radio_2" class="with-gap" v-model="soal_1" value="tidak" disabled><label for="radio_2">Tidak</label>
                                                </div>
                                                <br>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">2.</td>
                                              <td>
                                                Apakah Saudara sudah memahami inti-inti dari isi Juknis BOS 2017? <br> <br>
                                                <div class="demo-radio-button">
                                                  <input name="group2" type="radio" id="radio_3" class="with-gap" v-model="soal_2" value="ya" disabled><label for="radio_3">Ya</label>
                                                  <input name="group2" type="radio" id="radio_4" class="with-gap" v-model="soal_2" value="tidak" disabled><label for="radio_4">Tidak</label>
                                                </div>

                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">3.</td>
                                              <td>
                                                Apakah program BOS sudah pernah disosialisasikan kepada orang tua murid/masyarakat lingkungan sekolah Saudara? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group3" type="radio" id="radio_5" class="with-gap" v-model="soal_3" value="ya" disabled><label for="radio_5">Ya</label>
                                                  <input name="group3" type="radio" id="radio_6" class="with-gap" v-model="soal_3" value="tidak" disabled><label for="radio_6">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">4.</td>
                                              <td>
                                                Sejak kapan Saudara menduduki jabatan ketua komite di sekolah ini? Sejak tahun… <input v-model="ket_4" type="text" disabled> <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group4" type="radio" id="radio_7" class="with-gap" v-model="soal_4" value="ya" disabled><label for="radio_7">Ya</label>
                                                  <input name="group4" type="radio" id="radio_8" class="with-gap" v-model="soal_4" value="tidak" disabled><label for="radio_8">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">5.</td>
                                              <td>
                                                Selain dana BOS, apakah terdapat sumber dana lain untuk mendukung operasional sekolah? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group5" type="radio" id="radio_9" class="with-gap" v-model="soal_5" value="ya" disabled><label for="radio_9">Ya</label>
                                                  <input name="group5" type="radio" id="radio_10" class="with-gap" v-model="soal_5" value="tidak" disabled><label for="radio_10">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">6.</td>
                                              <td>
                                                Jika jawaban Saudara pada poin “5” adalah Ya, dari mana saja sumber dana bantuan operasional sekolah yang saudara ketahui selain BOS?
                                                    <ul>
                                                        <li v-for="dn in soal_6" :key="dn.id">
                                                          {{dn.data}}
                                                        </li>
                                                    </ul>

                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">7.</td>
                                              <td>
                                                7.	Apakah selama periode April-Juni dan Juli-September 2017, pihak sekolah menghimpun dana dari orang tua/wali siswa? <br><br>

                                                <div class="demo-radio-button">
                                                  <input name="group7" type="radio" id="radio_11" class="with-gap" v-model="soal_7" value="ya" disabled><label for="radio_11">Ya</label>
                                                  <input name="group7" type="radio" id="radio_12" class="with-gap" v-model="soal_7" value="tidak" disabled><label for="radio_12">Tidak</label>
                                                  <input name="group7" type="radio" id="radio_13" class="with-gap" v-model="soal_7" value="tidak tahu" disabled><label for="radio_13">Tidak Tahu</label>
                                                </div>

                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">8.</td>
                                              <td>
                                                Apakah penyusun Rencana Anggaran Pendapatan dan Belanja Sekolah (RAPBS)  tahun pelajaran 2017/2018, pihak sekolah melibatkan Komite Sekolah? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group8" type="radio" id="radio_14" class="with-gap" v-model="soal_8" value="ya" disabled><label for="radio_14">Ya</label>
                                                  <input name="group8" type="radio" id="radio_15" class="with-gap" v-model="soal_8" value="tidak" disabled><label for="radio_15">Tidak</label>
                                                  <input name="group8" type="radio" id="radio_16" class="with-gap" v-model="soal_8" value="tidak tahu" disabled><label for="radio_16">Tidak Tahu</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">9.</td>
                                              <td>
                                                Siapa yang bertanda tangan pada RAPBS terakhir yang sekarang Saudara menjadi Komite Sekolah? <br><br>
                                                <div class="demo-radio-button">

                                                  <input name="group9" type="radio" id="radio_17" class="with-gap" v-model="soal_9" value="kepala sekolah" disabled><label for="radio_17">Kepala Sekolah</label>
                                                  <input name="group9" type="radio" id="radio_18" class="with-gap" v-model="soal_9" value="ketua komite" disabled><label for="radio_18">Ketua Komite</label>
                                                  <input name="group9" type="radio" id="radio_19" class="with-gap" v-model="soal_9" value="dinas pendidikan kab/kota" disabled><label for="radio_19">Dinas Pendidikan Kabupaten/Kota</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">10.</td>
                                              <td>
                                                Berapa dana BOS yang diterima sekolah setiap triwulan tahun 2017? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group10" type="radio" id="radio_20" class="with-gap" v-model="soal_10" value="ya" disabled><label for="radio_20">Ya</label>
                                                  <input name="group10" type="radio" id="radio_21" class="with-gap" v-model="soal_10" value="tidak" disabled><label for="radio_21">Tidak</label>
                                                  <input name="group10" type="radio" id="radio_22" class="with-gap" v-model="soal_10" value="tidak tahu" disabled><label for="radio_22">Tidak Tahu</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">11.</td>
                                              <td>
                                                Apakah saat dana BOS didistribusikan sekolah setiap triwulan selalu diberitahukan kepala Saudara? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group11" type="radio" id="radio_23" class="with-gap" v-model="soal_11" value="ya" disabled><label for="radio_23">Ya</label>
                                                  <input name="group11" type="radio" id="radio_24" class="with-gap" v-model="soal_11" value="tidak" disabled><label for="radio_24">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">12.</td>
                                              <td>
                                                Apakah saat rapat rencana penggunaan dan BOS pertriwulan selalu dilibatkan Komite Sekolah? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group12" type="radio" id="radio_25" class="with-gap" v-model="soal_12" value="ya" disabled><label for="radio_25">Ya</label>
                                                  <input name="group12" type="radio" id="radio_26" class="with-gap" v-model="soal_12" value="tidak" disabled><label for="radio_26">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">13.</td>
                                              <td>
                                                Jika jawaban Saudara pada poin ”12 ”Ya”, siapa yang hadir dalam rapat pembahasan pemanfaatan dana BOS selain Kepala Sekolah? <br><br>
                                                <div class="demo-checkbox">
                                                  <input type="checkbox" id="basic_checkbox_1" v-model="soal_13_a" class="filled-in" disabled> <label for="basic_checkbox_1">Wakil Kepala Sekolah</label> <br>
                                                  <input type="checkbox" id="basic_checkbox_2" v-model="soal_13_b" class="filled-in" disabled> <label for="basic_checkbox_2">Ketua Komite Sekolah</label><br>
                                                  <input type="checkbox" id="basic_checkbox_3" v-model="soal_13_c" class="filled-in" disabled> <label for="basic_checkbox_3">Bendahara Pengelola dana BOS</label><br>
                                                  <input type="checkbox" id="basic_checkbox_4" v-model="soal_13_d" class="filled-in" disabled> <label for="basic_checkbox_4">Perwakilan Guru</label><br>

                                                </div>
                                                <i style="font-size:85%">* (Jawaban pilihan bisa lebih dari satu) *</i>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">14.</td>
                                              <td>
                                                Apakah Saudara mengetahui adanya pengaduan masyarakat terkait pelaksanaan program BOS di Sekolah Saudara?<br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group14" type="radio" id="radio_27" class="with-gap" v-model="soal_14" value="ya" disabled><label for="radio_27">Ya</label>
                                                  <input name="group14" type="radio" id="radio_28" class="with-gap" v-model="soal_14" value="tidak" disabled><label for="radio_28">Tidak</label>
                                                  <input name="group14" type="radio" id="radio_29" class="with-gap" v-model="soal_14" value="tidak tahu" disabled><label for="radio_29">Tidak Tahu</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">15.</td>
                                              <td>
                                                Apakah Saudara terlibat dalam penanganan  pengaduan masyarakat?<br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group15" type="radio" id="radio_30" class="with-gap" v-model="soal_15" value="ya" disabled><label for="radio_30">Ya</label>
                                                  <input name="group15" type="radio" id="radio_31" class="with-gap" v-model="soal_15" value="tidak" disabled><label for="radio_31">Tidak</label>

                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">16.</td>
                                              <td>
                                                Apakah Saudara terlibat dalam penanganan  pengaduan masyarakat?<br><br>
                                                <table>
                                                  <thead style="background: #e0e0e0">
                                                    <tr>
                                                      <th rowspan="2" class="text-center">Nomor</th>
                                                      <th rowspan="2" class="text-center">Permasalahan</th>
                                                      <th colspan="3" class="text-center">Penanganan Pengaduan</th>
                                                    </tr>

                                                    <tr>
                                                      <th class="text-center">Masuk</th>
                                                      <th class="text-center">Selesai</th>
                                                      <th class="text-center">Belum</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <td>1.</td>
                                                      <td>Pemanfaatan dana BOS</td>
                                                      <td>{{ket_16_masuk_01}}</td>
                                                      <td>{{ket_16_selesai_01}}</td>
                                                      <td>{{ket_16_belum_01}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>2.</td>
                                                      <td>Pengembalian kelebihan penerimaan dana BOS</td>
                                                      <td>{{ket_16_masuk_02}}</td>
                                                      <td>{{ket_16_selesai_02}}</td>
                                                      <td>{{ket_16_belum_02}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>3.</td>
                                                      <td>Transparansi pengelolaan dana BOS</td>
                                                      <td>{{ket_16_masuk_03}}</td>
                                                      <td>{{ket_16_selesai_03}}</td>
                                                      <td>{{ket_16_belum_03}}</td>
                                                    </tr>
                                                    <tr>
                                                      <td>4.</td>
                                                      <td>Lainnya …………………………………</td>
                                                      <td>{{ket_16_masuk_04}}</td>
                                                      <td>{{ket_16_selesai_04}}</td>
                                                      <td>{{ket_16_belum_04}}</td>
                                                    </tr>
                                                    <tr style="background: #e0e0e0">
                                                      <td colspan="2" class="text-center">JUMLAH</td>
                                                      <td>{{ket_16_masukx}}</td>
                                                      <td>{{ket_16_selesaix}}</td>
                                                      <td>{{ket_16_belumx}}</td>
                                                    </tr>

                                                  </tbody>
                                                </table>

                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">17.</td>
                                              <td>
                                                Apakah Saudara mengetahui Sekolah telah membuat Laporan Akhir Pelaksanaan Program BOS?<br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group17" type="radio" id="radio_32" class="with-gap" v-model="soal_17" value="ya" disabled><label for="radio_32">Ya</label>
                                                  <input name="group17" type="radio" id="radio_33" class="with-gap" v-model="soal_17" value="tidak" disabled><label for="radio_33">Tidak</label>

                                                </div>
                                              </td>
                                          </tr>

                                          <tr class="h_isitable">
                                              <td class="text-center"></td>
                                              <td>
                                                <br>
                                                <i>Saran :</i> <br>
                                                <br>
                                                <div class="form-group">
                                                        <div class="form-line">
                                                            {{saran}}
                                                        </div>
                                                    </div>
                                              </td>
                                          </tr>

                                        </tbody>
                                    </table>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>




      </div>
    </section>
  </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/ver_instrumen_komite_sekolah/';


export default {
  name: "monev_ver_instrumen_komite_sekolah",
  data() {
    return {
      data_id : '',
      soal_1 : '',
      soal_2 : '',
      soal_3 : '',
      soal_4 : '', ket_4 : '',
      soal_5 : '',
      soal_6 : [],
      soal_6_push : '',
      soal_7 : '',
      soal_8 : '',
      soal_9 : '',
      soal_10 : '',
      soal_11 : '',
      soal_12 : '',
        soal_13_a : false,
        soal_13_b : false,
        soal_13_c : false,
        soal_13_d : false,
      soal_14 : '',
      soal_15 : '',
        ket_16_masuk_01 : '',
        ket_16_selesai_01 : '',
        ket_16_belum_01 : '',
        ket_16_masuk_02 : '',
        ket_16_selesai_02 : '',
        ket_16_belum_02 : '',
        ket_16_masuk_03 : '',
        ket_16_selesai_03 : '',
        ket_16_belum_03 : '',
        ket_16_masuk_04 : '',
        ket_16_selesai_04 : '',
        ket_16_belum_04 : '',
        ket_16_masuk_05 : '',
        ket_16_selesai_05 : '',
        ket_16_belum_05 : '',
      soal_17 : '',
      saran : '',

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    viewId : function(data_id){
      this.data_id = data_id
    },

    setujuiData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'diterima',

        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });
    },

    kembalikanData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'dikembalikan',
        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });

    },

    viewData : function(data_cari){
      fetch(ADD_URL+'view_one', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: data_cari,
        })
      }).then(res => res.json())
        .then((data_res) => {

          // console.log(data_res.data);


          if (data_res.data == null) {
            this.counter = true
          } else {
            this.counter = false
          }

          this.soal_1 = data_res.data.soal_1;
          this.soal_2 = data_res.data.soal_2;
          this.soal_3 = data_res.data.soal_3;
          this.soal_4 = data_res.data.soal_4; this.ket_4 = data_res.data.ket_4;
          this.soal_5 = data_res.data.soal_5;
          this.soal_6 = data_res.data.soal_6;
          this.soal_7 = data_res.data.soal_7;
          this.soal_8 = data_res.data.soal_8;
          this.soal_9 = data_res.data.soal_9;
          this.soal_10 = data_res.data.soal_10;
          this.soal_11 = data_res.data.soal_11;
          this.soal_12 = data_res.data.soal_12;
            this.soal_13_a = data_res.data.soal_13_a;
            this.soal_13_b = data_res.data.soal_13_b;
            this.soal_13_c = data_res.data.soal_13_c;
            this.soal_13_d = data_res.data.soal_13_d;
          this.soal_14 = data_res.data.soal_14;
          this.soal_15 = data_res.data.soal_15;
            this.ket_16_masuk_01 = data_res.data.ket_16_masuk_01;
            this.ket_16_selesai_01 = data_res.data.ket_16_selesai_01;
            this.ket_16_belum_01 = data_res.data.ket_16_belum_01;
            this.ket_16_masuk_02 = data_res.data.ket_16_masuk_02;
            this.ket_16_selesai_02 = data_res.data.ket_16_selesai_02;
            this.ket_16_belum_02 = data_res.data.ket_16_belum_02;
            this.ket_16_masuk_03 = data_res.data.ket_16_masuk_03;
            this.ket_16_selesai_03 = data_res.data.ket_16_selesai_03;
            this.ket_16_belum_03 = data_res.data.ket_16_belum_03;
            this.ket_16_masuk_04 = data_res.data.ket_16_masuk_04;
            this.ket_16_selesai_04 = data_res.data.ket_16_selesai_04;
            this.ket_16_belum_04 = data_res.data.ket_16_belum_04;
            this.ket_16_masuk_05 = data_res.data.ket_16_masuk_05;
            this.ket_16_selesai_05 = data_res.data.ket_16_selesai_05;
            this.ket_16_belum_05 = data_res.data.ket_16_belum_05;
          this.soal_17 = data_res.data.soal_17;
          this.saran = data_res.data.saran;

        })
    },


    cekStatus : function(data){
      if(data == 'diterima'){
        return {background : '#e4ffc4'}
      }
      else if (data == 'dikembalikan') {
        return {background : '#ffcece'}
      }
    },

// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================



  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
  },
  computed: {

    ket_16_selesaix : function(){
      return parseFloat(this.ket_16_selesai_01)+ parseFloat(this.ket_16_selesai_02) + parseFloat(this.ket_16_selesai_03) + parseFloat(this.ket_16_selesai_04)
    },
    ket_16_belumx : function(){
      return parseFloat(this.ket_16_belum_01)+ parseFloat(this.ket_16_belum_02) + parseFloat(this.ket_16_belum_03) + parseFloat(this.ket_16_belum_04)
    },
    ket_16_masukx : function(){
      return parseFloat(this.ket_16_masuk_01)+ parseFloat(this.ket_16_masuk_02) + parseFloat(this.ket_16_masuk_03) + parseFloat(this.ket_16_masuk_04)
    },
  },
};
</script>

